<template>
    <div :class="['single-select', clazz]">
        <v-popselect
            ref="pop"
            :clazz="popClass"
            :offset="offset"
            :disabled="disabled"
            :placement="placement"
            :value="currentValue"
            :options="options"
            @select="handleSelect"
        />
        <div
            v-popselect:pop.click
            :class="[
                'single-select-trigger',
                { 'is-placeholder': options.length === 0 || currentValue === null, 'trigger-invalid': !valid }
            ]"
        >
            <slot
                name="header"
                :current="current"
            >
                <span>{{ currentText }}</span>
            </slot><v-icon
                class="single-select-trigger-arrow"
                name="arrow_dropdown"
            />
        </div>
    </div>
</template>

<script>
export default {
  name: 'SingleSelect',
  props: {
    valid: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [Number, String],
      default: null,
    },
    offset: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clazz: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
  },

  data() {
    return {
      currentValue: this.value,
      popClass: `single-select-pop${this.clazz ? ` ${this.clazz}-pop` : ''}`,
    };
  },

  computed: {
    current() {
      return this.options.find(op => op.value === this.currentValue);
    },

    currentText() {
      if (this.options.length === 0 || this.currentValue === null) {
        return this.placeholder;
      }
      return this.current && this.current.text;
    },
  },

  watch: {
    value(val) {
      this.currentValue = val;
    },
  },

  methods: {
    handleSelect(item) {
      this.currentValue = item.value;
      this.$emit('input', item.value);
      this.$emit('select', item.current);
    },
  },
};
</script>

<style lang="less">
.single-select {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    color: #1e2330;

    .single-select-trigger {
        cursor: pointer;
        color: currentColor;

        &-arrow {
            margin-left: 5px;
            width: 10px;
            height: 10px;
            color: currentColor;
            cursor: pointer;
        }

        &.is-placeholder {
            color: #a8abb3;
        }
    }
}

.single-select-pop {
    z-index: 22222 !important;
    margin-top: -5px;
    min-width: 150px;
}
</style>
